import React, {lazy, Suspense} from 'react'
import LoadingCircle from "../../../Loading/LoadingCircle";

const PrayerBookDetailPageLazy = lazy(() =>
    import('./PrayerBookDetailPage')
)

const PrayerBookDetailPage = props => (
    <Suspense fallback={<LoadingCircle/>}>
        <PrayerBookDetailPageLazy {...props} />
    </Suspense>
)

export default PrayerBookDetailPage
